import Vue from 'vue';
export default {
  namespaced: true,
  state: () => ({ requests: {} }),
  mutations: {
    createRequest(state, id) {
      Vue.set(state.requests, id, { status: 'pending' });
    },
    setRequestDone(state, id) {
      if (state.requests[id]) Vue.set(state.requests[id], 'status', 'done');
    },
    setRequestError(state, id) {
      if (state.requests[id]) Vue.set(state.requests[id], 'status', 'error');
    },
    removeRequest(state, id) {
      Vue.delete(state.requests, id);
    },
  },
  getters: {
    getRequestStatus: (state) => (id) => state.requests[id]?.status || 'idle',
  },
};
